import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { siteConfig } from '@/mocks/siteConfig';

export default function HeroSection() {
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      navigate(`/category/zixun`);
    }
  };

  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20modern%20Chinese%20style%20website%20background%20with%20warm%20gradient%20tones%20of%20coral%20red%20and%20soft%20cream%2C%20flowing%20organic%20shapes%2C%20geometric%20patterns%20inspired%20by%20traditional%20Chinese%20motifs%2C%20clean%20minimal%20aesthetic%2C%20soft%20atmospheric%20lighting%2C%20elegant%20contemporary%20design%2C%20no%20text%2C%20no%20people%2C%20abstract%20art%20style&width=1800&height=900&seq=hero-bg-99net&orientation=landscape"
          alt="久久网背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 text-center py-20">
        <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 font-[var(--font-heading)] tracking-tight">
          久久网
        </h1>
        <p className="text-lg md:text-xl text-white/90 mb-2">
          官方入口 · 海量资源一站直达
        </p>
        <p className="text-sm md:text-base text-white/70 mb-8 max-w-2xl mx-auto leading-relaxed">
          {siteConfig.description}
        </p>

        <form onSubmit={handleSearch} className="max-w-xl mx-auto mb-12">
          <div className="flex items-center bg-white/95 backdrop-blur-sm rounded-full overflow-hidden shadow-lg">
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="搜索感兴趣的内容..."
              className="flex-1 px-6 py-4 text-sm text-foreground-900 bg-transparent border-none outline-none placeholder:text-foreground-400"
            />
            <button
              type="submit"
              className="px-8 py-4 bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              搜索
            </button>
          </div>
        </form>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-3xl mx-auto">
          {[
            { label: '文章总数', value: siteConfig.stats.totalArticles.toLocaleString() },
            { label: '累计用户', value: siteConfig.stats.totalUsers },
            { label: '日访问量', value: siteConfig.stats.dailyVisitors },
            { label: '内容分类', value: `${siteConfig.stats.categories}大类` },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white mb-1">{stat.value}</div>
              <div className="text-xs md:text-sm text-white/60">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}